<template>
  <BaseModal :title="modalTitle" v-on="$listeners" class="audit-criteria-modal">
    <template v-slot:openBtn="{ openModal }">
      <a
        :class="$style.informationOpenBtn"
        class="has-text-right"
        @click="openModal"
      >
        <b-icon icon="information-outline"> </b-icon>
      </a>
    </template>
    <template v-slot:modalBody>
      <div>
        <div>
          <label class="label" :class="['margin-bottom16', $style.title]"
            >Best Practice Recommendation</label
          >
          <div :class="$style.content">
            <template
              v-for="(
                bestPracticeRecommendation, index
              ) in criteria.bestPracticeRecommendations"
            >
              <div class="columns margin-bottom8">
                <div class="column is-1 has-text-right text-size">
                  {{ index + 1 }}.
                </div>
                <div class="column text-size">
                  {{ bestPracticeRecommendation }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <hr class="break-auditcriteria-detail" />
        <div>
          <label class="label" :class="['margin-bottom16', $style.title]"
            >Derived From</label
          >
          <label
            class="label"
            :class="['margin-bottom11 bold', $style.title]"
            >{{ criteria.document.title }}</label
          >
          <div :class="$style.content">
            <a
              :class="['text-size', $style.documentLink]"
              target="_blank"
              :href="`/documents/${criteria.document.id}`"
            >
              {{ criteria.document.id }}
              <b-icon
                size="is-small"
                pack="fas"
                icon="external-link-alt"
              ></b-icon>
            </a>
            <div :class="['text-size', $style.content]">
              {{ criteria.document.description }}
            </div>
          </div>
        </div>
        <div :class="$style.paddingTop">
          <label class="label" :class="['margin-bottom16', $style.title]"
            >Tags</label
          >
          <div v-if="criteria.tags.mesh.length > 0">
            <b-tag
              v-for="tag in criteria.tags.mesh"
              :key="`mesh${tag}`"
              :class="$style.tag"
              type="is-primary"
            >
              {{ tag }}
            </b-tag>
          </div>
          <div v-if="criteria.tags.plain.length > 0">
            <b-tag
              v-for="(tag, index) in criteria.tags.plain"
              :key="`plain${index}`"
              :class="$style.tag"
              type="is-primary"
            >
              {{ tag }}
            </b-tag>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import { CplusCriteria } from '@/store/modules/projects/types/projects.types';

@Component({
  components: {
    BaseModal,
  },
})
export default class AuditCriteriaDetailModal extends Vue {
  public modalTitle: string = 'Data Collection Period Criteria Details';
  @Prop() public criteria!: CplusCriteria;
}
</script>
<style>
/** not a good practise fix **/
.audit-criteria-modal .modal-card-foot {
  border: 0;
}
</style>
<style module>
.criteriaTitle {
  font-weight: 700;
}
.criteriaBooleanOptions,
.criteriaCheckBoxOptions,
.criteriaRangeOptions {
  padding-top: 15px;
}
.paddingTop {
  padding-top: 20px;
}
.criteriaDocumentDetails {
  background: #f4faff;
}
.title {
  color: #444f51;
  font-size: 16px;
  font-weight: 400;
}
.content {
  color: #444f51;
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
}
.tag {
  margin-right: 8px;
}
.documentLink {
  padding-top: 15px;
  padding-bottom: 15px;
  color: #21b5ea;
  font-size: 14px;
  font-weight: 400;
}
.informationOpenBtn {
  color: #21b5ea;
}
</style>
